$(document).ready(function () {
    if ($(".container-masonry-gallery")[0]) {
        $('.tab-pane.active .container-masonry-gallery .masonry-gallery-item:lt(4)').css('display', 'flex');
        $('.load-less-gallery').hide();
        var items = 8;
        var shown = 2;
        $('.tab-pane.active .load-more-gallery').click(function () {
            shown = $('.tab-pane.active .container-masonry-gallery .masonry-gallery-item:visible').length + 2;
            if (shown < items) {
                $('.tab-pane.active .container-masonry-gallery .masonry-gallery-item:lt(' + shown + ')').css('display', 'flex').hide().fadeIn();
            } else {
                $('.tab-pane.active .container-masonry-gallery .masonry-gallery-item:lt(' + items + ')').css('display', 'flex').hide().fadeIn();
                $('.tab-pane.active .load-more-gallery').hide();
                $('.tab-pane.active .load-less-gallery').show();
            }
        });
        $('.load-less-gallery').click(function () {
            $([document.documentElement, document.body]).animate({
                scrollTop: $("#gallery_section_start").offset().top
            }, 100);
            $('.tab-pane.active .container-masonry-gallery .masonry-gallery-item').not(':lt(4)').hide(500).fadeOut();
            $('.tab-pane.active .load-more-gallery').show();
            $('.tab-pane.active .load-less-gallery').hide();
        });
        $(".nav-link-gallery").click(function (){
            setTimeout(function (){
                $('.tab-pane.active .container-masonry-gallery .masonry-gallery-item').not(':lt(4)').hide(500).fadeOut();
                $('.tab-pane.active .load-more-gallery').show();
                $('.tab-pane.active .load-less-gallery').hide();
                $('.tab-pane.active .container-masonry-gallery .masonry-gallery-item:lt(4)').css('display', 'flex');
                $('.load-less-gallery').hide();
                var items = 8;
                var shown = 2;
                $('.tab-pane.active .load-more-gallery').click(function () {
                    shown = $('.tab-pane.active .container-masonry-gallery .masonry-gallery-item:visible').length + 2;
                    if (shown < items) {
                        $('.tab-pane.active .container-masonry-gallery .masonry-gallery-item:lt(' + shown + ')').css('display', 'flex').hide().fadeIn();
                    } else {
                        $('.tab-pane.active .container-masonry-gallery .masonry-gallery-item:lt(' + items + ')').css('display', 'flex').hide().fadeIn();
                        $('.tab-pane.active .load-more-gallery').hide();
                        $('.tab-pane.active .load-less-gallery').show();
                    }
                });
                $('.load-less-gallery').click(function () {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $("#gallery_section_start").offset().top
                    }, 100);
                    $('.tab-pane.active .container-masonry-gallery .masonry-gallery-item').not(':lt(4)').hide(500).fadeOut();
                    $('.tab-pane.active .load-more-gallery').show();
                    $('.tab-pane.active .load-less-gallery').hide();
                });
            }, 400)

        })

    }
});